import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
			headerContainer: {
				height: 60,
				background: '#f4f4f9',
				borderBottom: `1px solid ${theme.palette.grey[200]}`,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				position: 'absolute',
				top: 0,
				width: '100%',
				[theme.breakpoints.down('sm')]: {
					padding: `0px ${theme.spacing(1)}px`,
				},
				boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.2)',
			},
			titleSection: {
				width: '100%',
				maxWidth: '650px',
				[theme.breakpoints.up('md')]: {
					width: '650px',
				},

			},
			headerTitle: {
				fontSize: '24px',
				fontWeight: 'bold',
				color: '#1B1A7C',
				paddingLeft: '8px',
				[theme.breakpoints.down('sm')]: {
					fontSize: '20px',
					[theme.breakpoints.down('xs')]: {
						fontSize: '18px',
						textAlign: 'center'
					},
				},
			},
			closeButton: {
				display: 'block',
				position: 'absolute',
				left: '10px',
				width: 24,
				height: 24,
				padding: 0,
				[theme.breakpoints.down('sm')]: {
					left: 5,
					right:'10px'
				},
			},
		},
	)
